export const IneligiblePerson = {
    SPOUSE: "Spouse",
    CHILD: "Child",
    CHILD_SPOUSE: "Spouse_Child",
    INSURED: "Insured"
}
export const IneligibleOptions = {
    SPOUSE: "Spouse",
    INSURED: "Myself"
}

const nestedPathCache = new Map();

const getNestedPathSegments = (path) => {
    const cachedPath = nestedPathCache.get(path);
    if (cachedPath) {
        return cachedPath;
    }

    const segments = [];
    let token = '';

    for (let index = 0; index < path.length; index += 1) {
        const char = path[index];

        if (char === '.' || char === '[' || char === ']') {
            if (token) {
                segments.push(/^\d+$/.test(token) ? Number(token) : token);
                token = '';
            }
            continue;
        }

        token += char;
    }

    if (token) {
        segments.push(/^\d+$/.test(token) ? Number(token) : token);
    }

    nestedPathCache.set(path, segments);
    return segments;
};

export const setNestedValue = (target, path, value) => {
    if (!target || !path) {
        return target;
    }

    const segments = getNestedPathSegments(path);
    let current = target;
    const lastSegmentIndex = segments.length - 1;

    for (let index = 0; index < lastSegmentIndex; index += 1) {
        const segment = segments[index];

        if (current[segment] == null) {
            current[segment] = typeof segments[index + 1] === 'number' ? [] : {};
        }

        current = current[segment];
    }

    current[segments[lastSegmentIndex]] = value;
    return target;
};
